import { render, staticRenderFns } from "./CashAccountStep2UserAccount.vue?vue&type=template&id=5c4d4f4b"
import script from "./CashAccountStep2UserAccount.vue?vue&type=script&lang=js"
export * from "./CashAccountStep2UserAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports